/**
 * CSV / TSV を RFC 4180 準拠でパースする。ダブルクォートによる囲み・クォート内の
 * 区切り文字/改行・"" によるエスケープ・CRLF を扱う。表示用途なので、閉じ忘れの
 * クォート等の不正な入力もエラーにせず読めるところまで読む。
 */
export function parseDelimited(text: string, delimiter: "," | "\t"): string[][] {
	const rows: string[][] = [];
	let row: string[] = [];
	let field = "";
	let inQuotes = false;
	// 空ファイルと「空フィールド1つの行」を区別するため、行に何か書いたかを覚えておく。
	let rowHasContent = false;

	const endField = () => {
		row.push(field);
		field = "";
		rowHasContent = true;
	};
	const endRow = () => {
		endField();
		rows.push(row);
		row = [];
		rowHasContent = false;
	};

	for (let i = 0; i < text.length; i++) {
		const ch = text[i];
		if (inQuotes) {
			if (ch === '"') {
				if (text[i + 1] === '"') {
					field += '"';
					i++;
				} else {
					inQuotes = false;
				}
			} else {
				field += ch;
			}
		} else if (ch === '"' && field === "") {
			inQuotes = true;
			rowHasContent = true;
		} else if (ch === delimiter) {
			endField();
		} else if (ch === "\n" || ch === "\r") {
			endRow();
			if (ch === "\r" && text[i + 1] === "\n") i++;
		} else {
			field += ch;
		}
	}
	// 末尾に改行がない最終行。改行で終わるファイルでは空行を作らない。
	if (field !== "" || row.length > 0 || rowHasContent) endRow();
	return rows;
}
